import { render, staticRenderFns } from "./view-admin.vue?vue&type=template&id=692adbe2&scoped=true"
import script from "./view-admin.vue?vue&type=script&lang=js"
export * from "./view-admin.vue?vue&type=script&lang=js"
import style0 from "./view-admin.vue?vue&type=style&index=0&id=692adbe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692adbe2",
  null
  
)

export default component.exports